




























import { Component, Mixins } from "vue-property-decorator";
import UserTopbarDropdown from "@/components/UserTopbarDropdown.vue";
import LanguageTopbarDropdown from "@/components/LanguageTopbarDropdown.vue";
import PrintAwareMixin from "@/mixins/PrintAwareMixin";
import { currentUserStore, projectStore } from "@/store/typed";

@Component({ components: { UserTopbarDropdown, LanguageTopbarDropdown } })
export default class TheTopbar extends Mixins(PrintAwareMixin) {
  get currentUser() {
    return currentUserStore.currentUser;
  }

  goToProjectList() {
    projectStore.setCurrentProject(undefined);
    projectStore.$validateProject();

    this.$router.push({ name: "projects-list" });
  }
}
